/// <reference path="../typings/index.d.ts" />
/// <reference path="ModelView.d.ts" />
namespace App {
  export class ModelView implements IModelView {
    private ajax: IAjax;
    private form: JQuery = null;
    public _this: any = null;
    public elBtnExcluir: JQuery = $(".btn-excluir");
    public elBtnEditar: JQuery = $(".btn-editar");
    public elBtnCopiar: JQuery = $(".btn-copiar");
    private elBtnAtivarDesativar: JQuery = $(".btn-ativar-desativar");
    public static acaoAposExclusao: any = null;
    public static acaoAposSalvar: any = null;
    public aoEditarRegistro: any = (e: JQueryEventObject, _this: any) => { };
    public textoConfirmacaoExclusao: string = 'Essa ação não poderá ser revertida.';
    public pedirConfirmacaoExclusao: boolean = true;
    public validacaoAntesDeSalvar: any = null;
    public acaoAposCopiarRegistro: any = null;
    public ojDataTableCarregado: { elDataTable: JQuery, objDataTable: any, acaoAposExclusao: any, metodoSelecionarDeselecionar: any, acoesButtonExtra: any[], metodoSelecionarDeselecionarComplemento: any, excluindo: boolean } = { elDataTable: null, excluindo: false, objDataTable: null, acaoAposExclusao: () => { }, metodoSelecionarDeselecionar: null, acoesButtonExtra: [], metodoSelecionarDeselecionarComplemento: (count: number) => { } };
    private aoSelecionarOuDeselecionar: any = (e: any, dt: any, type: any, indexes: any) => { };
    private acoesButton: any[] = [];

    public inicializar(elFom: JQuery = null, validar: boolean = false, acaoAposExclusao: any = null, acaoAposSalvar: any = null) {
      this.form = elFom;
      if (this.form) {
        this.form.on('submit', (e) => { this.aoSalvarRegistroPorModal(e, validar); });
      }
      this.elBtnExcluir.on("click", (e) => { this.aoExcluirRegistro(e) });
      this.elBtnCopiar.on("click", (e) => { this.aoCopiarRegistro(e) });
      this.elBtnEditar.on("click", (e) => { this.aoEditarRegistro(e, this._this) });
      this.elBtnAtivarDesativar.on("click", (e) => { this.aoAtivarDesativarRegistro(e) });
      App.ModelView.acaoAposExclusao = acaoAposExclusao;
      App.ModelView.acaoAposSalvar = acaoAposSalvar;
    }

    public inicializarBotaoExcluir(btnExcluir: JQuery) {
      btnExcluir.on("click", (e) => { this.aoExcluirRegistro(e) });
    }

    public aoSalvarRegistroPorModal(e: JQueryEventObject, validar: boolean = false) {
      if (this.validacaoAntesDeSalvar) {
        e.preventDefault();
      }

      var seletorModalContexto: string = "#" + $(e.currentTarget).parents('.modal').attr('id');
      if (validar && !$(e.currentTarget).valid()) {
        e.preventDefault();
        return;
      }


      if (this.validacaoAntesDeSalvar) {
        this.validacaoAntesDeSalvar(e, () => {
          this.ajax = new App.Ajax();
          this.ajax.postModal(e, seletorModalContexto, App.ModelView.acaoAposSalvar);
        })
      } else {
        this.ajax = new App.Ajax();
        this.ajax.postModal(e, seletorModalContexto, App.ModelView.acaoAposSalvar);
      }
    }

    public aoAtivarDesativarRegistro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcao($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id") });
    }

    public aoExcluirRegistro(e: JQueryEventObject) {
      if (this.pedirConfirmacaoExclusao) {
        App.Util.exebirSweetConfirmacao(e, "Você tem certeza disso?", this.textoConfirmacaoExclusao, "Sim, continuar", this.excluirRegistro);
        return;
      }
      this.excluirRegistro(e);
    }
    public aoCopiarRegistro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id") }, this.acaoAposCopiarRegistro, e);
    }

    private excluirRegistro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id") }, App.ModelView.acaoAposExclusao, e);
    }

    private excluirRegistroSelecionados(ids: number[]) {
      this.ajax = new App.Ajax();
      this.ajax.postAcao(this.ojDataTableCarregado.elDataTable.data('urlExcluir'), { ids: ids }, (resposta: any) => {
        this.ojDataTableCarregado.excluindo = true;
        if (resposta && resposta.dadosRetornados && resposta.dadosRetornados.dadosResposta) {
          let elementoStrLineExluir = ids.map(num => `tr#${num}`).join(',');
          this.ojDataTableCarregado.elDataTable.find(elementoStrLineExluir).remove()
        }
      });
    }

    public carregardataTable(acoesBotoesPersonalizados: any[] = null, quantidadePorPagina: number = 200) {
      if (this.ojDataTableCarregado && this.ojDataTableCarregado.elDataTable) {
        this.acoesButton = acoesBotoesPersonalizados != null ? acoesBotoesPersonalizados : [
          {
            className: "btn-sm btn-outline-primary btn-selecionar-tudo",
            text: '<i title="Select/Unselect all" class="fas fa-check-double font-size-11 m-0"></i>',
            action: () => {
              let itensSelecionados = this.ojDataTableCarregado.objDataTable.rows({ selected: true })
              let count = itensSelecionados.count();
              if (count) {
                this.ojDataTableCarregado.objDataTable.rows().deselect();
              } else {
                this.ojDataTableCarregado.objDataTable.rows().select();
              }
            }
          },
          {
            className: "btn-sm btn-outline-primary btn-excluir-selecionados",
            text: 'Excluir',
            action: () => {
              let itensSelecionados = this.ojDataTableCarregado.objDataTable.rows({ selected: true })
              let count = itensSelecionados.count();
              if (count) {
                if (this.ojDataTableCarregado.excluindo) {
                  return
                }

                this.excluirRegistroSelecionados(itensSelecionados.ids().toArray())
              }
            }
          }
        ]

        if (this.ojDataTableCarregado.acoesButtonExtra.length) {
          this.acoesButton = [... this.acoesButton, this.ojDataTableCarregado.acoesButtonExtra]
        }

        this.ojDataTableCarregado.objDataTable = this.ojDataTableCarregado.elDataTable.DataTable({
          language: {
            paginate: {
              previous: "<i class='fas fa-angle-left'>",
              next: "<i class='fas fa-angle-right'>"
            }
          },
          order: [[0, "asc"]],
          lengthChange: false,
          pageLength: quantidadePorPagina,
          dom: "Bfrtip",
          rowId: 'id',
          select: true,
          buttons: this.acoesButton
        } as any);

        this.aoSelecionarOuDeselecionar = (e: any, dt: any, type: any, indexes: any) => {
          if (type === 'row') {
            let itensSelecionados = this.ojDataTableCarregado.objDataTable.rows({ selected: true })
            let count = itensSelecionados.count();

            $('.btn-excluir-selecionados').html(count > 0 ? `Excluir (${count})` : `Excluir`)
            this.ojDataTableCarregado.metodoSelecionarDeselecionarComplemento(count)
          }
        }

        this.ojDataTableCarregado.objDataTable.on('select', this.ojDataTableCarregado.metodoSelecionarDeselecionar ? this.ojDataTableCarregado.metodoSelecionarDeselecionar : this.aoSelecionarOuDeselecionar);
        this.ojDataTableCarregado.objDataTable.on('deselect', this.ojDataTableCarregado.metodoSelecionarDeselecionar ? this.ojDataTableCarregado.metodoSelecionarDeselecionar : this.aoSelecionarOuDeselecionar);
      }
    }

    public getIdsContasSelecionadas(): number[] {
      let contasSelecionadas = this.getContasSelecionadas()
      return contasSelecionadas.ids().toArray()
    }

    public getContasSelecionadas() {
      return this.ojDataTableCarregado.objDataTable.rows({ selected: true })
    }
  }

}
